import OSS from "ali-oss";
import md5 from "js-md5";
import Compressor from "compressorjs";

const client = new OSS({
  region: "oss-accelerate",
  accessKeyId: "LTAI4GL1qJp41iBHMoSo33GX",
  accessKeySecret: "tqXbD8ieSzChFLoqTC8W4xDAwTW7vz",
  bucket: "vchat-tigo-res"
});
const uploadToOSS = (filename, file, resolve, type = "image/png") => {
  
  client
    .put(filename, file, {
      mime: type // 设置 Content-Type 默认为 image/png
    })
    .then((resp) => {
      if (resp.res.status === 200) {
        resolve(resp.url.replace("vchat-tigo-res.oss-accelerate.aliyuncs.com","res.tigo.chat"));
      } else {
        this.showToast($t('upload_failed'));
      }
    });
};
/**
 *
 * @param {文件} file
 * @param {类型} type
 * @param {图片压缩质量} quality
 * @returns
 */
const upload = (file, type, quality = 1) => {
  const dateNow = Date.now();
  const year = String(new Date().getFullYear());
  const month = String(new Date().getMonth() + 1);
  const day = String(new Date().getDate());
  let suffix;
  if(file.type.split("/")[1] === 'quicktime') {
    suffix = 'mov'
  }else {
    suffix = file.type.split("/")[1]
  }
  
  const filename =
    "webapp/" +
    type +
    "/" +
    year +
    "/" +
    (month < 10 ? "0" + month : month) +
    "/" +
    (day < 10 ? "0" + day : day) +
    "/" +
    md5(dateNow + "web") +
    "." +
    suffix;

  console.log('name:', filename)
  return new Promise((resolve) => {
    if (type == "img") {
      console.log("压缩质量",quality)
      new Compressor(file, {
        convertSize: 100000,
        quality: quality,
        maxHeight:4000,
        maxWidth:4000,
        success(result) {
          uploadToOSS(filename, result, resolve);
        },
        error() {
          uploadToOSS(filename, file, resolve);
        }
      });
    } else {
      uploadToOSS(filename, file, resolve, type);
    }
  });
};

export function base64ToFile(base64, filename, mimeType = "image/png") {
  // 移除Base64前缀（如果有）
  const base64Data = base64.split(",")[1] || base64;

  // 将Base64转换为二进制数据
  const byteString = atob(base64Data);

  // 创建ArrayBuffer和Uint8Array
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  // 填充数据
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // 创建Blob对象
  const blob = new Blob([ab], { type: mimeType });

  // 转换为File对象
  return new File([blob], filename, { type: mimeType });
}

export default upload;
